module.exports = __webpack_public_path__ + "static/media/LoaderDNA.c5982718.gif";